/**
 * The printed newsletters, newest first.
 *
 * The organisation's own publication — three or four issues a year since 2014 — as
 * against the five thousand partner-unit updates the sidebar calls "Updates". They share
 * a word in English and nothing else; see the head of migration 0023.
 *
 * The shelf and the two windows an issue can open in are PdfShelf, shared with the annual
 * reports. What is written here is only what differs: an issue is addressed by the day it
 * went out rather than by a year, and there are enough of them that the card wants the
 * month at a glance rather than the full date.
 */
import { PageHeader } from '../App'
import { useApi } from '../lib/api'
import PdfShelf from '../components/PdfShelf'
import { fmtDate } from '../components/ui'

/**
 * The line across the top of a card: "March 2014".
 *
 * Read off the stored text rather than through a Date, on purpose. `issue_date` is
 * 'YYYY-MM-DD' and the four and two characters at the front of it are the year and the
 * month whatever timezone the reader is in — where `new Date('2014-03-28')` is midnight
 * UTC, which west of Greenwich is still the twenty-seventh, and a shelf that renamed an
 * issue depending on who was looking at it would be a small, permanent puzzle.
 */
const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
]
const monthOf = (iso) => `${MONTHS[Number(String(iso).slice(5, 7)) - 1]} ${String(iso).slice(0, 4)}`

export default function NewsletterIssues() {
  const query = useApi('newsletter-issues', 'newsletter-issues')

  return (
    <PageHeader
      title="Newsletters"
      sub="The printed newsletters sent to supporters, one for each issue"
    >
      <PdfShelf
        query={query}
        base="newsletter-issues"
        noun="newsletter"
        icon="newspaper"
        describe={(r) => ({ heading: monthOf(r.issue_date), sub: fmtDate(r.issue_date) })}
        nameOf={(r) => `the ${monthOf(r.issue_date)} newsletter`}
        windowTitle={(r) => `${r.title} — ${fmtDate(r.issue_date)}`}
        emptyTitle="No newsletters yet"
        emptyBody={
          <>
            Issues are added on Imports → Import Newsletters, which reads each file and
            shelves it under the date in its filename.
          </>
        }
      />
    </PageHeader>
  )
}
